/* LEDFROST v2 — cart reservation timer, scroll rail + back to top, compact countdown labels. */
(function () {
  'use strict';
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('lf-data') || {}).textContent || '{}'); } catch (e) {}
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- 5-minute cart reservation ---- */
  var KEY = 'lf_hold_end', DUR = 5 * 60 * 1000, timer = null, count = 0;
  function end() {
    var e = 0;
    try { e = parseInt(sessionStorage.getItem(KEY), 10); } catch (x) {}
    if (!e || e <= Date.now()) {
      e = Date.now() + DUR;
      try { sessionStorage.setItem(KEY, String(e)); } catch (x) {}
    }
    return e;
  }
  function paint() {
    var left = Math.max(0, end() - Date.now());
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    $$('[data-lf-hold]').forEach(function (el) {
      el.hidden = !count;
      el.classList.toggle('is-hot', left < 60000);
      var t = el.querySelector('[data-lf-hold-t]'); if (t) t.textContent = txt;
      var b = el.querySelector('[data-lf-hold-bar]'); if (b) b.style.width = (left / DUR * 100) + '%';
    });
  }
  function sync(n) {
    count = n || 0;
    if (count && !timer) timer = setInterval(paint, 1000);
    if (!count && timer) { clearInterval(timer); timer = null; }
    paint();
  }

  /* drawer : follow what the cart renders */
  var body = document.querySelector('[data-lf-cartbody]');
  if (body && 'MutationObserver' in window) {
    new MutationObserver(function () {
      sync(body.querySelectorAll('.lf-li').length);
      $$('.lf-li img', body).forEach(function (img) {
        if (!img.getAttribute('src')) { img.style.visibility = 'hidden'; }
      });
    }).observe(body, { childList: true });
  }

  /* full /cart page */
  if (/\/cart\/?$/.test(location.pathname)) {
    var tpl = document.getElementById('lf-hold-tpl');
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (tpl && tpl.content && main) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var h = node.querySelector('.lf-hold'); if (h) h.classList.add('lf-hold--page');
      main.insertBefore(node, main.firstChild);
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { sync(c.item_count); })
        .catch(function () {});
    }
  }

  /* ---- compact countdown labels (j / h / m / s) for phones ---- */
  var S = CFG.cd_s || { d: 'j', h: 'h', m: 'm', s: 's' };
  $$('[data-lf-cd]').forEach(function (cd) {
    function label() {
      var u = cd.querySelectorAll('.lf-cd__u'), keys = ['s', 'm', 'h', 'd'];
      for (var i = u.length - 1, k = 0; i >= 0; i--, k++) {
        if (u[i].querySelector('.lf-cd__s')) continue;
        var n = u[i].querySelector('.lf-cd__n');
        if (!n) continue;
        var sp = document.createElement('span');
        sp.className = 'lf-cd__s'; sp.textContent = S[keys[k]] || '';
        n.insertAdjacentElement('afterend', sp);
      }
    }
    if ('MutationObserver' in window) new MutationObserver(label).observe(cd, { childList: true });
    label();
  });

  /* ---- branded scroll rail + back to top ---- */
  var pw = document.querySelector('.page-wrapper');
  var useEl = !!(pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 4);
  var sc = useEl ? pw : (document.scrollingElement || document.documentElement);

  var wrap = document.createElement('div');
  wrap.className = 'lf';
  wrap.innerHTML =
    '<div class="lf-rail" aria-hidden="true"><i></i></div>' +
    '<button type="button" class="lf-top" aria-label="' + (CFG.t_top || 'Revenir en haut') + '">' +
    '<svg class="lf-top__ring" viewBox="0 0 52 52" aria-hidden="true"><defs><linearGradient id="lf-top-g" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#0E4FE1"/><stop offset=".6" stop-color="#45C6FF"/><stop offset="1" stop-color="#E32330"/></linearGradient></defs>' +
    '<circle class="bg" cx="26" cy="26" r="23"/><circle class="fg" cx="26" cy="26" r="23"/></svg>' +
    '<svg class="lf-top__a" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 14l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>';
  document.body.appendChild(wrap);

  var fill = wrap.querySelector('.lf-rail i'), btn = wrap.querySelector('.lf-top'),
      ring = wrap.querySelector('.fg'), C = 144.5, raf = 0;
  function upd() {
    raf = 0;
    var max = sc.scrollHeight - sc.clientHeight;
    var y = useEl ? pw.scrollTop : (window.scrollY || sc.scrollTop || 0);
    var p = max > 0 ? Math.min(1, y / max) : 0;
    fill.style.transform = 'scaleY(' + p + ')';
    ring.style.strokeDashoffset = String(C - C * p);
    btn.classList.toggle('is-on', y > 500);
  }
  (useEl ? pw : window).addEventListener('scroll', function () {
    if (!raf) raf = requestAnimationFrame(upd);
  }, { passive: true });
  window.addEventListener('resize', upd);
  btn.addEventListener('click', function () {
    (useEl ? pw : window).scrollTo({ top: 0, behavior: 'smooth' });
  });
  upd();
})();
